/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const contextMenuTriggerType = Object.freeze({
  CALENDAR: "calendar",
  RIGHT_CLICK: "rightClick",
  TEXT_SELECTION: "textSelection",
  COMMENT_SELECTED: "commentSelected",
  COLOR_PICKER: "colorPicker",
  SCALE_ANNOT: "scaleAnnot",
  HUD_OVERFLOW_BUTTON_CLICK: "hudOverflowButtonClick",
  EDIT_TEXT: "editTextClick",
  EDIT_IMAGE: "editImageClick",
  EDIT_EMPTY_SPACE: "editEmptySpaceClick",
  HYPERLINK_CLICK: "hyperlinkClick",
  IMAGE_CLICK: "imageClick",
  IMAGE_SELECTION: "imageSelection"
});
export const canvasOperation = Object.freeze({
  CANVAS_OP_NONE: 0,
  CANVAS_OP_SELECTION: 1,
  CANVAS_OP_FIND: 2
});

export const editPDFButtonInfo = Object.freeze({
  WIDTH: 32,
  HEIGHT: 32,
  POSITION: 100
});

export const clickTypes = Object.freeze({
  NO_CLICK: 0,
  SINGLE_CLICK: 1,
  DOUBLE_CLICK: 2,
  TRIPLE_CLICK: 3
});

export const QUAD_TYPE = Object.freeze({
  DEF_SEARCH_RESULT: 0,
  CURR_SEARCH_RESULT: 1,
  CARET_QUAD: 2
});

export const failureType = Object.freeze({
  NONE: "none",
  PASSWORD_PROTECTED: "passwordProtected",
  READ_ONLY_DOCUMENT: "readOnlyDocument",
  PORT_FOLIO_FILE: "portFolioFile",
  ENCRYPTED_DOCUMENT: "encryptedDocument",
  DIGITALLY_SIGNED_DOCUMENT: "digitallySignedDocument",
  POLICY_PROTECTED_DOCUMENT: "policyProtectedDocument",
  SUPPRESSED_PASSWORD_DIALOG: "suppressedPasswordDialog",
  SCANNED_DOCUMENT: "scannedDocument",
  NO_PASSWORD_PROVIDED: "noPasswordProvided",
  GENERIC_ERROR: "genericError",
  PRINT_FAILED_FOR_PASSWORD_PROTECTED_DOCUMENT:
    "PrintFailedForPasswordProtectedDocument"
});

export const pdfEditOperations = Object.freeze({
  COMMENT_CREATED: "commentCreated",
  COMMENT_DELETED: "commentDeleted",
  COMMENT_EDITED: "commentEdited",
  ACROFORM_FIELD_EDITED: "acroFormFieldEdited",
  ACROFORM_FIELD_CREATED: "acroFormFieldCreated",
  ACROFORM_FIELD_DELETED: "acroFormFieldDeleted",
  ACROFORM_FIELDS_LOCKED: "acroFormFieldsLocked",
  SIGN_METADATA_EDITED: "signMetadataEdited",
  FAS_FIELD_CREATED: "fasFieldCreated",
  FAS_FIELD_DELETED: "fasFieldDeleted",
  FAS_FIELD_EDITED: "fasFieldEdited",
  FAS_FIELDS_FLATTENED: "fasFieldsFlattened",
  ORGANIZE_PAGE_ROTATED: "organizePageRotated",
  ORGANIZE_PAGE_DELETED: "organizePageDeleted",
  ORGANIZE_PAGE_INSERTED: "organizePageInserted",
  ORGANIZE_PAGE_REORDERED: "organizePageReordered",
  TEXT_EDITED: "textEdited",
  IMAGE_EDITED: "imageEdited",
  PDF_CLEANED: "pdfCleaned",
  DO_NOT_SAVE: "doNotSave",
  CROP_PAGES: "cropPages",
  NUMBER_PAGES: "numberPagesAdded",
  HYPERLINK_DELETED: "hyperlinkDeleted",
  HYPERLINK_CREATED: "hyperlinkCreated",
  HYPERLINK_EDITED: "hyperlinkEdited",
  PDF_MODIFIED: "pdfModified",
  NUMBER_PAGES_REMOVED: "numberPagesRemoved",
  PAGE_OCRED: "pageOCRed"
});

// media query types
export const mqTypes = Object.freeze({
  DEVICE_WIDTH: "DEVICE_WIDTH",
  FORCED_COLORS: "FORCED_COLORS"
});

export const textManagerMode = Object.freeze({
  SELECTION: "selection",
  CARET: "caret"
});

export const CaretShortcut = {
  NONE: 0,
  LINE_BEGIN: 1,
  LINE_END: 2
};

export const LIB_VERSION = Object.freeze({
  RSPV2: "rsp-v2",
  RSPV3: "rsp-v3"
});
